













import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'SocialMedia',
})
export default class SocialMedia extends Vue {
    private socialMedias = [
      {
        icon: 'instagram',
        title: '/highstormrecords',
        link: 'https://www.instagram.com/highstormrecords/',
      },
      {
        icon: 'youtube',
        title: 'HighStormRecords',
        link: 'https://www.youtube.com/channel/UCIoxczOpGkMuzRqM7RciJSw',
      },
      {
        icon: 'facebook',
        title: 'High Storm Records',
        link: 'https://www.facebook.com/High-Storm-Records-157266163110973/',
      },
    ];
}
